import { faker } from '@faker-js/faker';
import { Factory, trait } from 'miragejs';

export default Factory.extend({
  name() {
    return faker.random.alpha({ count: 5, casing: 'mixed' });
  },

  isAdmin() {
    return false;
  },

  admin: trait({
    isAdmin() {
      return true;
    },

    afterCreate(user, server) {
      user.update({
        userRoles: server.createList('user-role', 1, 'admin'),
      });
    },
  }),

  editor: trait({
    afterCreate(user, server) {
      user.update({
        userRoles: server.createList('user-role', 1, 'editor'),
      });
    },
  }),

  job: trait({
    afterCreate(user, server) {
      user.update({
        userRoles: server.createList('user-role', 1, 'job'),
      });
    },
  }),

  umgClassicEvent: trait({
    afterCreate(user, server) {
      user.update({
        userRoles: server.createList('user-role', 1, 'umgClassicEvent'),
      });
    },
  }),

  management: trait({
    afterCreate(user, server) {
      user.update({
        userRoles: server.createList('user-role', 1, 'management'),
      });
    },
  }),

  customerSupport: trait({
    afterCreate(user, server) {
      user.update({
        userRoles: server.createList('user-role', 1, 'customerSupport'),
      });
    },
  }),

  noPermissions: trait({
    afterCreate(user, server) {
      user.update({
        userRoles: server.createList('user-role', 1, 'noPermissions'),
      });
    },
  }),
});
